import '../styles/design-system.css'
import '../styles/VerificationResult.css'

const VerificationResult = ({ result, documentData, userData, onRestart }) => {
  const isApproved = result.verification?.status === 'approved'
  const similarity = result.faceMatch?.similarity || 0
  const rejectionReasons = result.verification?.rejectionReasons || result.rejectionReasons || []
  const nameMatch = result.nameMatch || null
  const cpfMatch = result.cpfMatch || null

  // Get rejection message
  const getRejectionMessage = () => {
    if (rejectionReasons.length > 0) {
      return rejectionReasons.join('. ')
    }
    return 'O rosto não coincide com o documento.'
  }

  // Extract OCR data from documentData if available
  const ocrData = documentData?.ocr?.data || null

  // Format CPF for display
  const formatCpf = (cpf) => {
    if (!cpf) return '-'
    const digits = cpf.replace(/\D/g, '')
    if (digits.length === 11) {
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`
    }
    return cpf
  }

  const hasComparisonDetails = !isApproved && (nameMatch || cpfMatch || ocrData || userData)

  return (
    <div className="verification-result-container">
      <div className={`result-card ${isApproved ? 'approved' : 'rejected'}`}>
        <div className="result-icon">
          {isApproved ? '✅' : '❌'}
        </div>

        <h2 className="result-title">
          {isApproved ? 'Verificação Aprovada!' : 'Verificação Reprovada'}
        </h2>

        <p className="result-message">
          {isApproved
            ? 'Você já pode fechar essa tela.'
            : getRejectionMessage()}
        </p>

        {hasComparisonDetails && (
          <div className="extracted-data">
            <h3>Detalhes da Verificação</h3>

            {/* Name comparison */}
            {(userData?.nome || nameMatch || ocrData?.nome) && (
              <div className="comparison-section">
                <div className="comparison-label">Nome</div>
                <div className="data-grid">
                  {userData?.nome && (
                    <div className="data-item">
                      <span className="data-label">Informado</span>
                      <span className="data-value">{userData.nome}</span>
                    </div>
                  )}
                  {ocrData?.nome && (
                    <div className="data-item">
                      <span className="data-label">No documento</span>
                      <span className="data-value">{ocrData.nome}</span>
                    </div>
                  )}
                  {nameMatch && (
                    <div className={`data-item ${nameMatch.match ? 'match-ok' : 'match-fail'}`}>
                      <span className="data-label">Resultado</span>
                      <span className="data-value">
                        {nameMatch.match ? 'Confere' : 'Não confere'}
                        {nameMatch.explanation && ` — ${nameMatch.explanation}`}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* CPF comparison */}
            {(userData?.cpf || cpfMatch || ocrData?.cpf) && (
              <div className="comparison-section">
                <div className="comparison-label">CPF</div>
                <div className="data-grid">
                  {userData?.cpf && (
                    <div className="data-item">
                      <span className="data-label">Informado</span>
                      <span className="data-value">{formatCpf(userData.cpf)}</span>
                    </div>
                  )}
                  {ocrData?.cpf && (
                    <div className="data-item">
                      <span className="data-label">No documento</span>
                      <span className="data-value">{formatCpf(ocrData.cpf)}</span>
                    </div>
                  )}
                  {cpfMatch && (
                    <div className={`data-item ${cpfMatch.match ? 'match-ok' : 'match-fail'}`}>
                      <span className="data-label">Resultado</span>
                      <span className="data-value">
                        {cpfMatch.match ? 'Confere' : 'Não confere'}
                        {cpfMatch.explanation && ` — ${cpfMatch.explanation}`}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Face similarity if available */}
            {result.faceMatch && !result.faceMatch.match && (
              <div className="comparison-section">
                <div className="comparison-label">Reconhecimento Facial</div>
                <div className="data-grid">
                  <div className="data-item match-fail">
                    <span className="data-label">Similaridade</span>
                    <span className="data-value">{similarity.toFixed(1)}% (mínimo 85%)</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {!isApproved && (
          <button onClick={onRestart} className="btn-restart">
            Tentar Novamente
          </button>
        )}
      </div>
    </div>
  )
}

const formatLabel = (key) => {
  const labels = {
    nome: 'Nome',
    cpf: 'CPF',
    rg: 'RG',
    dataNascimento: 'Data de Nascimento',
    numeroRegistro: 'Número do Registro',
    categoria: 'Categoria',
    dataEmissao: 'Data de Emissão',
    dataValidade: 'Data de Validade',
    numeroRG: 'Número do RG',
    naturalidade: 'Naturalidade',
    orgaoEmissor: 'Órgão Emissor'
  }
  return labels[key] || key
}

export default VerificationResult
